import React from 'react';

function SignUp() {
    return ( <h1>Sign Up Section</h1> );
}

export default SignUp;